// eslint-disable-next-line simple-import-sort/imports
import {
  DatesSetArg,
  EventClickArg,
  EventContentArg
} from "@fullcalendar/core"; // must go before plugins
import itLocale from "@fullcalendar/core/locales/it";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import {
  Day,
  DayWithHolidaysForCal,
  GetHoursOffPerMonthQueryVariables,
  UserForCalendar,
  combineDateAndTime,
  getStartEndOfMonthExpanded,
  groupUsersByDay,
  useGetHoursOffPerMonthQuery
} from "@mc-intranet/shared";
import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  MyTheme,
  TextField,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useAtom, useAtomValue } from "jotai";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { authStorageAtom, holydaysByYearsAtom } from "../../atoms";
import { useGraphQLClient } from "../../cache";
import CalendarWrapper from "../../components/Calendar";

const TimbraturePage = () => {
  const authStorage = useAtomValue(authStorageAtom);
  const { user } = authStorage;

  const isDesktop = useMediaQuery((theme: MyTheme) =>
    theme.breakpoints.up("md")
  );

  const { client } = useGraphQLClient();
  const [holidays, setHolidays] = useAtom(holydaysByYearsAtom);
  const [calData, setCalData] = useState<any[]>(Object.values(holidays).flat());
  const [modalVisible, setModalVisible] = useState(false);
  const [usersForInDay, setUsersForInDay] = useState<{
    dateStr: string;
    users: UserForCalendar[];
  }>({
    dateStr: "",
    users: []
  });
  const [variables, setVariables] = useState<GetHoursOffPerMonthQueryVariables>(
    {
      startDate: getStartEndOfMonthExpanded(moment()).startOfMonth,
      endDate: getStartEndOfMonthExpanded(moment()).endOfMonth
    }
  );

  const [userOnVacations, setUserOnVacations] = useState<
    { label: string; value: string }[]
  >([]);
  const [filteredUserOnVacations, setFilteredUserOnVacations] = useState<
    { label: string; value: string }[]
  >([]);

  const { data, isLoading: loadingUsers } = useGetHoursOffPerMonthQuery(
    client,
    variables,
    {
      enabled: !!user,
      onError: (error: any) => {
        toast.error(error?.response?.error.message, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }
  );

  const dateChange = (arg: DatesSetArg) => {
    // console.log("datesSet", arg);
    // aggiorno le vacanze se cambia l'anno
    const start = moment(arg.start).year();
    const end = moment(arg.end).year();
    const isOverlapping = start !== end;
    if (isOverlapping) {
      console.log("set isOverlapping");
      setHolidays([start, end]);
    } else {
      // console.log("set year");
      setHolidays(end);
    }

    setVariables((prev) => {
      return {
        ...prev,
        startDate: moment(arg.start).format("YYYY-MM-DD"),
        endDate: moment(arg.end).format("YYYY-MM-DD")
      };
    });
  };

  useEffect(() => {
    if (data) {
      const days = data?.days;
      const { grouped, users } = groupUsersByDay(days as Day[]);
      const items = [];

      for (const [key, value] of Object.entries(grouped)) {
        console.log(`${key}: ${value}`);
        const _item: DayWithHolidaysForCal = {
          id: key,
          start: key,
          extendedProps: { users: value },
          backgroundColor: "transparent",
          borderColor: "transparent"
        };
        items.push(_item);
      }

      setUserOnVacations(users);
      setCalData([...Object.values(holidays).flat(), ...items]);
    }
  }, [data, holidays]);

  interface UsersInPermessoProps {
    isModal?: boolean;
    dateStr: string;
    users: UserForCalendar[];
  }

  const UsersInPermesso: React.FC<UsersInPermessoProps> = (props) => {
    const { isModal = false, dateStr, users } = props;
    // console.log(`users`, users);

    return (
      <Box
        className="users-in-permesso-cell"
        overflow="auto"
        display={isModal ? "inherit" : { xs: "flex", md: "inherit" }}
        flexWrap="wrap"
        p={{ xs: 0, md: 1 }}
        sx={{ pointerEvents: "visible" }}
        justifyContent="center"
      >
        {users &&
          users?.map((item) => {
            const hoursOff = item?.hoursOff;
            const firstName = item?.user?.firstName ?? "";
            const lastName = item?.user?.lastName ?? "";
            const color = item?.user?.color ?? "";
            // controllo i filtri

            const Hours = () => {
              return (
                <Box
                  display={isModal ? "flex" : { xs: "none", md: "flex" }}
                  flexDirection="column"
                  alignItems="flex-start"
                  marginLeft={1}
                >
                  {hoursOff?.map((value, index) => {
                    return (
                      <Typography
                        key={index}
                        fontSize="13px"
                      >{`(${combineDateAndTime(
                        dateStr,
                        value?.from,
                        "HH:mm"
                      )} - ${combineDateAndTime(
                        dateStr,
                        value?.to,
                        "HH:mm"
                      )}) \n`}</Typography>
                    );
                  })}
                </Box>
              );
            };

            const UserWithHours = () => {
              return (
                <Box
                  color="text.primary"
                  display="flex"
                  alignItems="flex-start"
                  justifyContent="space-between"
                  width={isModal ? "100%" : { xs: "auto", md: "100%" }}
                  margin={isModal ? 0 : { xs: "2px", md: 0 }}
                >
                  <Box
                    color="text.primary"
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <Box
                      component="span"
                      bgcolor={color}
                      borderRadius="50%"
                      marginRight={isModal ? 1 : { xs: 0, md: 1 }}
                      width={isModal ? 8 : { xs: 5, md: 8 }}
                      height={isModal ? 8 : { xs: 5, md: 8 }}
                    />
                    <Typography
                      fontSize="13px"
                      display={isModal ? "block" : { xs: "none", md: "block" }}
                    >{`${firstName.charAt(0)}.${lastName.substring(
                      0,
                      3
                    )}`}</Typography>
                  </Box>
                  <Hours />
                </Box>
              );
            };

            if (filteredUserOnVacations.length === 0) {
              return <UserWithHours key={color} />;
            } else {
              let _color = "";

              filteredUserOnVacations.forEach((selected) => {
                if (selected.value === color) {
                  _color = color;
                  return;
                }
              });

              if (_color !== "") return <UserWithHours key={_color} />;
            }
            return null;
          })}
      </Box>
    );
  };

  const renderEventContent = (eventContent: EventContentArg) => {
    const { event } = eventContent;
    const { display, extendedProps, startStr } = event;
    const { users } = extendedProps;
    if (display === "background") return;
    // console.log(`users`, users);

    return (
      <UsersInPermesso dateStr={startStr} users={users as UserForCalendar[]} />
    );
  };

  function handleUserChange(
    event: React.SyntheticEvent<Element, Event>,
    value: any
  ) {
    setFilteredUserOnVacations(value);
  }

  const onSelectDate = (arg: EventClickArg) => {
    // const date = moment(arg.dateStr);
    console.log("onSelectDate ", arg.event.startStr);
    setUsersForInDay({
      dateStr: arg.event.startStr,
      users: arg.event?.extendedProps["users"] as UserForCalendar[]
    });
    setModalVisible(true);
  };

  return (
    <Box pb={3}>
      <Box
        className="filters"
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingY={3}
      >
        <Autocomplete
          multiple
          disablePortal
          id="combo-box-demo"
          sx={{
            bgcolor: "background.default",
            marginInline: 2,
            maxWidth: "100%",
            minWidth: 260
          }}
          size="small"
          options={userOnVacations}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Utente"
              placeholder="Filtra per utente"
            />
          )}
          renderTags={(value, getTagProps) => {
            return value.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                sx={{ backgroundColor: option.value, color: "white" }}
                label={option.label}
              />
            ));
          }}
          onChange={handleUserChange}
        />
      </Box>
      <CalendarWrapper isLoading={loadingUsers}>
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          locale={itLocale}
          initialView="dayGridMonth"
          events={calData}
          eventContent={renderEventContent}
          datesSet={dateChange}
          eventClick={onSelectDate}
          headerToolbar={{
            start: "title",
            center: "",
            end: "today prevYear,prev,next,nextYear"
          }}
        />
      </CalendarWrapper>
      {!isDesktop && modalVisible && (
        <Dialog
          open={modalVisible}
          onBackdropClick={() => setModalVisible(false)}
        >
          <DialogTitle>
            <IconButton
              aria-label="close"
              onClick={() => setModalVisible(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500]
              }}
            >
              <Close />
            </IconButton>
            In Ferie
          </DialogTitle>
          <DialogContent sx={{ minWidth: "250px" }}>
            <UsersInPermesso
              dateStr={usersForInDay.dateStr}
              isModal
              users={usersForInDay.users}
            />
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default TimbraturePage;
